import { Component, Input, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../core/animations';

/**Local component */
import { ToggledListComponent } from '../toggled-list/toggledList.component';

/**Local file */

import { spekwoType } from '../../../../../utils/index';

import { SolutionFormService } from '../../../solutionForm.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'solutionMain',
    templateUrl: './solutionMain.component.html',
    styleUrls: ['./solutionMain.component.scss'],
    animations: fuseAnimations
})
export class SolutionMainComponent {

    @ViewChild(ToggledListComponent) child: ToggledListComponent;

    spekwoType = spekwoType;

    selected: any;
    @Input() reviewDetails: any = [];
    @Input() orderId;
    @Input() originalSolution;
    totalJobValue: any;
    insReportId: string;
    insReportIdChangeSubscription: Subscription;
    order: any;
    @Input() pageType: string;

    constructor(
        public location: Location,
        public solutionFormService: SolutionFormService,
        public router: ActivatedRoute
    ) {
    }

    ngOnInit() {

        // get current order from params
        this.router.params.subscribe(params => {
            this.orderId = params.id;
            this.insReportId = params.insReportId;
            this.pageType = params.pageType ? params.pageType : 'solutionPage';
        });


        this.insReportIdChangeSubscription =
            this.solutionFormService.insReportIdChange.subscribe(data => {
                this.insReportId = data && data.insReportId;
            });

        this.pageType ? this.pageType : 'solutionPage';
        this.insReportIdChangeSubscription =
            this.solutionFormService.insReportIdChange.subscribe(data => {
                this.insReportId = data && data.insReportId;
            })
    }

    ngOnDestroy() {
        this.insReportIdChangeSubscription.unsubscribe();
    }


    getTotalValue(totalJobValue) {
        this.totalJobValue = totalJobValue;
    }

    goback() {
        this.location.back();
    }

    /** To print document */
    printValue() {
        this.child.printDocument();
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/after-client-accept-list/solution-main/solutionMain.component.ts